module.exports = __webpack_public_path__ + "img/2.07.thmb.bc3ce0ce.jpg";